module.exports = __webpack_public_path__ + "static/media/background.1894f630.jpg";